
import { IonButton, IonCol, IonContent, IonGrid, IonInput, IonLabel, IonPage, IonRow, IonText, useIonRouter } from '@ionic/react';
import React, { useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Link, useHistory } from "react-router-dom";
import Footer from '../../components/Footer';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';


interface SignInProps{
  singIn:any,
  user?:User|null,
  refresh:any
}

const Signin: React.FC<SignInProps> = (props) => {


  const history = useIonRouter()
  const location=useHistory().location
  const state:any=location.state
  const user = props.user
  
  const siteText=translation();
  const lan = siteText.lan.replace("/","")
  const toAccountArray=["home","signin"]
  
  const authServ = new AuthServ();
  /**Define form fields */
  interface loginForm {
    email: string,
    password: string
  };

  const { control, handleSubmit } = useForm<loginForm>();
  const [isLogginInError, setIsLogginError] = useState<boolean>(false);



  const onSubmit: SubmitHandler<loginForm> = async (data) => {
    let auth=false;
    await authServ.authenticateUser(data).then(resp => {
      if (resp.message) {
        auth=true;
      } else {
        setIsLogginError(true);
        return
      }
    });
    if(auth){
      props.refresh();
      if(history.routeInfo.lastPathname && toAccountArray.some((item:string) => history.routeInfo.lastPathname?.includes(item)))  {
        history.push(`/${lan}/account`,'forward','replace');
      }else{
        if(location.state){
          history.push(`/${lan}${state.destination}`,'forward','replace');

        }else{
          history.goBack()
        }
      }
    }
    return
  }

  const LoginError = () => {
    if (isLogginInError) {
      return (
        <p>
          {siteText.loginError}
        </p>
      )
    } else {
      return <></>;
    }

  }

    return (
      <IonPage className='pageContent'>
        <IonContent>
          <IonGrid className='sw_sp_md'>
            {!user && <IonRow className='ion-justify-content-center ion-align-items-center '>
              <IonCol sizeSm='6' sizeMd="4" className=''>
                <h1 className='ion-text-center'>{siteText.loginTitle}</h1>
                <IonText color={isLogginInError ? 'danger' : 'success'}>
                  <LoginError></LoginError>
                </IonText>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <IonLabel className='ion-margin-top'>{siteText.loginEmailLabel}</IonLabel>
                  <Controller
                    control={control}
                    name="email"
                    rules={{
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message:siteText.loginEmailInvalidError
                      }
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top ion-margin-bottom'
                        type="email"
                        placeholder={siteText.loginEmailPlaceHolder}

                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}


                  />

                  <IonLabel >{siteText.loginPasswordLabel}</IonLabel>
                  <Controller
                    control={control}
                    name="password"
                    rules={{
                      required: true,
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top'
                        type="password"
                        placeholder={siteText.loginPasswordPlaceHolder}
                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}

                  />
                  <IonButton className='ion-margin-top' type="submit">{siteText.loginPrimary}</IonButton>
                </form>
                <p></p>
                <p><IonText><Link to={`/${lan}/signup`}>{siteText.loginNoAccount}</Link> </IonText> or <Link to={`/${lan}/password_reset`}>{siteText.loginLostPassword}</Link></p>
              </IonCol>
            </IonRow>}
            {
              user &&

              <IonRow>
                <IonCol offsetSm='3' sizeSm='6' offsetMd='4' sizeMd="4" className='ion-text-center'>
                <h1 className='ion-text-center'>{siteText.loginTitle}</h1>
                <p>{siteText.siteLoggedAlready}</p>
                <IonButton routerLink={`/${lan}/account/start`} fill='outline'> {siteText.siteToMyAccount}</IonButton>
                </IonCol>
              </IonRow>
            }
          </IonGrid>
        <Footer></Footer>
        </IonContent>
      </IonPage>
      
    );




};

export default Signin;
